/* UX guidelines */

.Tooltip3943902061__root {
  background-color: #fff;
  padding: 18px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.15), 0 6px 10px 0 rgba(0, 0, 0, 0.10), 0 1px 18px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  max-width: 264px;
  min-width: 36px;
}

.Tooltip3943902061__arrow,
.Tooltip3943902061__arrow::before {
  position: absolute;
  z-index: 1;
}

.Tooltip3943902061__arrow {
  visibility: hidden;
}

.Tooltip3943902061__arrow::before {
  visibility: visible;
  content: '';
  border: 9px solid;
  z-index: -1;
}

.Tooltip3943902061__arrow[data-arrow-placement^='top']::before {
  border-color: #fff transparent transparent transparent;
  transform: translateX(-9px);
  width: 100%;
  top: 0;
  left: 0;
}

.Tooltip3943902061__arrow[data-arrow-placement^='bottom']::before {
  border-color: transparent transparent #fff transparent;
  transform: translateX(-9px);
  width: 100%;
  bottom: 0;
  left: 0;
}

.Tooltip3943902061__arrow[data-arrow-placement^='left']::before {
  border-color: transparent transparent transparent #fff;
  transform: translateY(-9px);
  height: 100%;
  top: 0;
  left: 0;
}

.Tooltip3943902061__arrow[data-arrow-placement^='right']::before {
  border-color: transparent #fff transparent transparent;
  transform: translateY(-9px);
  height: 100%;
  top: 0;
  right: 0;
}

.Tooltip3943902061__contentContainer {
  width: 100%;
  height: 100%;
  overflow: auto;
}

/* st-namespace-reference="../../../../src/atoms/Tooltip/Tooltip.st.css" */